// src/app/shared/models/demand-status.ts
export enum DemandStatut {
  CHIFFRE = 'CHIFFRE',
  ENGAGE = 'ENGAGE',
  EN_ATTENTE = 'EN_ATTENTE',
  LIVRE = 'LIVRE',
  FERME = 'FERME',
  ANNULE = 'ANNULE'
}

export interface DemandStatusUpdateDTO {
  nouveauStatut: DemandStatut;
  motifRetour?: string;
  motifRefus?: string
}

export const DemandStatutLabel: Record<DemandStatut, string> = {
  [DemandStatut.EN_ATTENTE]: 'En attente',
  [DemandStatut.CHIFFRE]: 'Chiffré',
  [DemandStatut.ENGAGE]: 'Engagé',
  [DemandStatut.LIVRE]: 'Livré',
  [DemandStatut.FERME]: 'Fermé',
  [DemandStatut.ANNULE]: 'Annulé'
};